<div id="fb-root"></div>
<script async defer crossorigin="anonymous" src="https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v7.0"></script>
<!-- <app-navbar></app-navbar> -->

<mat-toolbar id="nav-bar">
  <span >
    <a routerLink="home">
      <img src="favicon.ico" id="logot">
      <span id="title">社會企業有限公司</span>
    </a>
  </span>
</mat-toolbar>

<div id="page-container">
    <mat-sidenav-container>
      <mat-sidenav class="sidenav" mode="side" opened>

        <!-- <div class="container"> -->

          <div class="col-lg homeCard" col-md-4 routerLink="/ehm">
            <h2 class="title">
              智保網
              <img class="titleLogo" src="assets/images/laptop_ehm.png"/>
            </h2>
            <p>智能院舍, 藥物管理, 電子派藥</p>
          </div>

          <div class="col-lg homeCard" routerLink="/course-registration" >
            <div class="row">
              <h2 class="title">
                HKIE CPD Course Registration
              </h2>
            </div>
          </div>

          <div class="col-lg homeCard" routerLink="/smart" >
            <div class="row">

              <h2 class="title">
                Smart
              <br/>
                Integration
              </h2>
              <img class="titleLogo" src="assets/images/SI-logo.png" />
            </div>
          </div>

          <div class="col-lg homeCard" col-md-4 routerLink="/hi" >
            <img class="titleLogo" src="assets/images/home-care-logo.png" />
            <h2 class="title">
              HI
          </h2>
          HI @ Home
        </div>

        <div class="col-lg homeCard" routerLink="/training" >
          <h2 class="title">
            智保康
            <img class="titleLogo" src="assets/images/pcw_logo.png" />
          </h2>
          <p>証書課程</p>
        </div>

        <!-- <div class="col-lg homeCard"  routerLink="/course" > -->
          <!-- <span class="badge badge-red badge-corner ">招生</span> -->
          <!-- <h3 class="title" style="padding-top:30px">
            資歷架構認可課程 -->
            <!-- <img class="titleLogo" src="assets/images/laptop_ehm.jpg" /> -->
          <!-- </h3> -->
          <!-- <p>2021年9月26日護理員訓練證書開課</p> -->
        <!-- </div> -->

        <!-- <div class="col-lg homeCard" routerLink="/six-arts" >
            <h2 class="title">
              六藝學坊
              <img class="titleLogo" src="assets/images/six_arts_logo.png" />
            </h2>
            <p>興趣班課程</p>

          </div> -->


          <div class="col-lg homeCard"  routerLink="/volunteer" >
            <h2 class="title" style="padding-top:25px">
              愛社區義工隊
              <!-- <img class="titleLogo" src="assets/images/laptop_ehm.jpg" /> -->
            </h2>
            <p></p>
          </div>

          <div class="col-lg homeCard"  routerLink="/activity" >
            <h2 class="title" style="padding-top:25px">
              社企活動
              <!-- <img class="titleLogo" src="assets/images/laptop_ehm.jpg" /> -->
            </h2>
            <p></p>
          </div>




          <div class="col-lg homeCard" col-md-4 routerLink="/demo" hidden>
            <h2 class="title">
              Demo
              <span style="color: Dodgerblue">
                <i class="fas fa-wrench"></i>
              </span>
            </h2>
            <p>Sign in require</p>
            </div>

          <div class="col-lg homeCard" routerLink="/demo" hidden>
            <h2 class="title">
              電子藥物管理
              <span style="color: Dodgerblue">
                <i class="fas fa-wrench"></i>
              </span>
            </h2>
            <p>Sign in require</p>
          </div>


        <!-- </div> -->
      </mat-sidenav>

      <mat-sidenav-content>

        <div id="content-wrap">
        <div class="container">


          <router-outlet></router-outlet>
        </div>

        <app-footer id="footer"></app-footer>
        <!-- <div style="padding-bottom:376px"></div> -->
        </div>
      </mat-sidenav-content>

    </mat-sidenav-container>


</div>
